import React from 'react';
import { createBrowserRouter, RouterProvider, Outlet } from 'react-router-dom';
import { AuthProvider } from './components/AuthProvider';
import AuthGuard from './components/AuthGuard';
import AppShell from './components/AppShell';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import UsersPage from './pages/UsersPage';
import RegistryPage from './pages/RegistryPage';
import EventsPage from './pages/EventsPage';
import DataSourcesPage from './pages/DataSourcesPage';
import StoriesPage from './pages/StoriesPage';
import StoryDetailPage from './pages/StoryDetailPage';
import AirframeStoriesPage from './pages/AirframeStoriesPage';
import AirframeStoryDetailPage from './pages/AirframeStoryDetailPage';
import StoryFeedbackPage from './pages/StoryFeedbackPage';
import AppFeedbackPage from './pages/AppFeedbackPage';
import SuppressionsPage from './pages/SuppressionsPage';

const RootLayout: React.FC = () => (
  <AuthProvider>
    <Outlet />
  </AuthProvider>
);

const router = createBrowserRouter([
  {
    element: <RootLayout />,
    children: [
      { path: '/login', element: <LoginPage /> },
      {
        element: (
          <AuthGuard>
            <AppShell />
          </AuthGuard>
        ),
        children: [
          { path: '/', element: <DashboardPage /> },
          { path: '/users', element: <UsersPage /> },
          { path: '/events', element: <EventsPage /> },
          { path: '/data-sources', element: <DataSourcesPage /> },
          { path: '/stories', element: <StoriesPage /> },
          { path: '/stories/:typeKey', element: <StoryDetailPage /> },
          { path: '/airframe-stories', element: <AirframeStoriesPage /> },
          { path: '/airframe-stories/:key', element: <AirframeStoryDetailPage /> },
          { path: '/story-feedback', element: <StoryFeedbackPage /> },
          { path: '/app-feedback', element: <AppFeedbackPage /> },
          { path: '/registry', element: <RegistryPage /> },
          { path: '/suppressions', element: <SuppressionsPage /> },
        ],
      },
    ],
  },
]);

const App: React.FC = () => <RouterProvider router={router} />;

export default App;
